import React from 'react';
import { motion } from 'framer-motion';
const features = [{
  icon: '🛠️',
  title: '40 Herramientas Clínicas',
  description: 'Recursos estructurados y listos para aplicar en tus sesiones.'
}, {
  icon: '📊',
  title: 'Matrices de Evaluación',
  description: 'Para identificar y registrar el perfil sensorial con precisión.'
}, {
  icon: '📋',
  title: 'Protocolos Paso a Paso',
  description: 'Guías claras sobre qué hacer, cuándo escalar y cuándo parar.'
}, {
  icon: '📍',
  title: 'Modelos para 3 Contextos',
  description: 'Adaptaciones específicas para Consultorio, Escuela y Casa.'
}, {
  icon: '📈',
  title: 'Indicadores de Avance',
  description: 'Métricas claras para medir el progreso real del niño.'
}, {
  icon: '📥',
  title: 'Plantillas Descargables',
  description: 'Formatos listos para imprimir y usar en tu práctica diaria.'
}];
export function FeaturesSection() {
  return <section id="features-section" className="bg-white py-16 px-6" data-id="element-50">
      <div className="max-w-4xl mx-auto" data-id="element-51">
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="font-display font-extrabold text-xs tracking-[0.18em] uppercase text-brand-green mb-3" data-id="element-52">
          Todo lo que recibes
        </motion.p>
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="font-display font-black text-3xl md:text-4xl uppercase mb-10 text-brand-ink" data-id="element-53">
          ¿Qué Incluye El Sistema?
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-54">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1,
          ease: [0.22, 1, 0.36, 1]
        }} whileHover={{
          y: -8,
          scale: 1.02,
          transition: {
            duration: 0.3
          }
        }} className="bg-white border border-gray-200 border-t-4 border-t-brand-green p-7 rounded text-center shadow-sm hover:shadow-md" data-id="element-55">
              <motion.div initial={{
            scale: 0,
            rotate: -180,
            y: -20
          }} whileInView={{
            scale: 1,
            rotate: 0,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.7,
            delay: index * 0.1 + 0.2,
            type: 'spring',
            stiffness: 200,
            damping: 12
          }} whileHover={{
            y: [-2, -6, -2],
            rotate: [0, 5, -5, 0],
            transition: {
              duration: 0.6,
              repeat: Infinity,
              repeatType: 'reverse'
            }
          }} className="text-4xl mb-4 inline-block" data-id="element-56">
                {feature.icon}
              </motion.div>
              <motion.h3 initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1 + 0.4
          }} className="font-display font-extrabold text-xl uppercase text-brand-green-dark mb-3 leading-tight" data-id="element-57">
                {feature.title}
              </motion.h3>
              <motion.p initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1 + 0.5
          }} className="text-gray-500 text-sm leading-relaxed" data-id="element-58">
                {feature.description}
              </motion.p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}